export default __webpack_public_path__ + "static/love_loyalty-2fb25f4157895a2e3b4fa9a84e5ac743.svg";